window.toggleMenu = (button) => {
  const menu = document.querySelector('.menu');
  menu?.classList.toggle('menu_active');
  button?.classList.toggle('header__catalog_active');
}

document.addEventListener('DOMContentLoaded', () => {
  const menuItemsWithChildren = document.querySelectorAll('.menu__item_parent > .menu__item-wrapper > .menu__item-link, .menu__item_parent .menu__item-caret');
  if (menuItemsWithChildren) {
    menuItemsWithChildren.forEach(item => {
      item.addEventListener('click', (event) => {
        if (window.matchMedia('(max-width: 1199px)').matches) {
          event.preventDefault();
          item.parentElement.parentElement.classList.toggle('menu__item_expanded');
        }
      });
    });
  }
});
